<template>
  <div>
      <div class="content" style="flex:5">
          <!-- 导航标签 -->
          <ul class="content_nav" style="margin-bottom:25px">
            <li @click="tiaozhuan('/index')">
                <span :class="{nav_active : (navActive==1)}">主页</span>
            </li>
            <li @click="tiaozhuan('/Assignment')">
                <span :class="{nav_active : (navActive==2)}">债权悬赏</span>
            </li>
            <li @click="tiaozhuan('/Court')">
                <span :class="{nav_active : (navActive==3)}">法院专栏</span>
            </li>
            <li>
                <span :class="{nav_active : (navActive==4)}">线索(开发中)</span>
            </li>
            <li>
                <span :class="{nav_active : (navActive==5)}">我的委托(开发中)</span>
            </li>
            
          </ul>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    navActive:{
        type:String,
        default:'1'
    }
  },
  data () {
    return {
      isActive:'0',
    }
  },
  mounted(){
    
    
  },
  methods:{
    tiaozhuan(url){
      this.$router.push({path:url})
    }


  },
  components:{

  },
}
</script>
<style scoped>
.index{
  width:100vw;
  display:flex;
}
.index .content{
  background:#f1f5f8;
}
.index .content .content_nav{
  overflow:hidden;
  background:#ffffff;
}
.index .content .content_nav li{
  float:left;
  box-sizing: border-box;
  height:80px;
  line-height:75px;
  text-align:center;
  width:20%;
  cursor: pointer;
}
.index .content .content_nav li:hover span{
  color: #2fb8c2;
  display: inline-block;
  width:50%;
  border-bottom: 5px solid #2fb8c2;
}
.index .content .content_nav li span.nav_active{
  color: #2fb8c2;
  display: inline-block;
  width:50%;
  border-bottom: 5px solid #2fb8c2;
}



</style>



// WEBPACK FOOTER //
// src/common/main_nav.vue